import { render, staticRenderFns } from "./ReviewYourAnswersRFLM.vue?vue&type=template&id=dabaeee8"
import script from "./ReviewYourAnswersRFLM.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersRFLM.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports